const organizations = {
    title: 'Organisations',
    description: 'Créez et gérez les organisations auxquelles vous appartenez.',
    create: 'Créer une organisation',
    create_title: 'Créer une nouvelle organisation',
    name: 'Nom de l’organisation',
    avatar: 'Avatar de l’organisation',
    avatar_removed: 'Avatar de l’organisation supprimé.',
    description_label: 'Description',
    empty: 'Vous n’appartenez à aucune organisation.',
    pending_invitations: 'Invitations en attente',
    accept: 'Accepter',
    decline: 'Refuser',
    owner: 'Propriétaire',
    tabs: {
        overview: 'Vue d’ensemble',
        members: 'Membres',
        invitations: 'Invitations',
        roles: 'Rôles de gestion',
        branding: 'Identité visuelle',
        security: 'Sécurité',
        jit: 'Provisionnement JIT',
        applications: 'Ressources partagées',
        activity: 'Activité',
        deletion: 'Supprimer',
    },
    members: {
        title: 'Membres',
        empty: 'Aucun membre trouvé.',
        remove: 'Retirer',
        removed: 'Membre retiré.',
        business_roles: 'Rôles métier',
        no_business_roles: 'Aucun rôle métier disponible. Demandez à l’administrateur du tenant de partager des rôles avec cette organisation.',
    },
    invitations: {
        title: 'Invitations',
        invite: 'Inviter un membre',
        email: 'Adresse e-mail',
        empty: 'Aucune invitation trouvée.',
        resend: 'Renvoyer',
        resent: 'Invitation renvoyée.',
        revoke: 'Révoquer',
        revoked: 'Invitation révoquée.',
        status: {
            Pending: 'En attente',
            Accepted: 'Acceptée',
            Expired: 'Expirée',
            Revoked: 'Révoquée',
            Declined: 'Refusée',
        },
    },
    roles: {
        title: 'Rôles de gestion',
        create: 'Créer un rôle',
        permissions: 'Autorisations',
        empty: 'Aucun rôle de gestion trouvé.',
        select_member: 'Sélectionner un membre',
        select_role: 'Sélectionner un rôle',
        assign: 'Attribuer un rôle',
        assigned: 'Rôle attribué.',
        unassign: 'Retirer un rôle',
        unassigned: 'Rôle retiré.',
        permission_count: 'Autorisations : {{count}}',
        built_in: {
            owner: 'Propriétaire',
            owner_description: 'Les propriétaires disposent des droits exclusifs de gestion de la propriété et de suppression de l’organisation.',
            administrator: 'Administrateur',
            administrator_description: 'Gérer l’organisation, sauf les actions réservées aux propriétaires.',
        },
        permission_labels: {
            update_profile: 'Modifier le profil',
            manage_branding: 'Gérer l’identité visuelle',
            view_members: 'Voir les membres',
            manage_members: 'Gérer les membres',
            manage_invitations: 'Gérer les invitations',
            assign_business_roles: 'Attribuer des rôles métier',
            manage_management_roles: 'Gérer les rôles de gestion',
            assign_management_roles: 'Attribuer des rôles de gestion',
            manage_security: 'Gérer la sécurité',
            manage_jit: 'Gérer le provisionnement JIT',
            manage_applications: 'Gérer les applications',
            view_activity: 'Voir l’activité',
        },
    },
    branding: {
        title: 'Identité visuelle de l’organisation',
        primary_color: 'Couleur principale',
        custom_css: 'CSS personnalisé',
        preview: 'Aperçu',
        light: 'Clair',
        dark: 'Sombre',
    },
    security: {
        title: 'Sécurité de l’organisation',
        require_mfa: 'Exiger l’authentification multifacteur pour les membres',
    },
    jit: {
        title: 'Domaines e-mail JIT',
        domain: 'Domaine e-mail',
        add: 'Ajouter un domaine',
        verify: 'Vérifier le DNS',
        dns_instruction: 'Créez l’enregistrement TXT {{record}} avec la valeur {{value}}.',
        verified: 'Vérifié',
    },
    applications: {
        title: 'Ressources partagées',
        empty: 'Aucune ressource disponible pour cette organisation.',
        sso: 'Connexions SSO d’entreprise',
        m2m: 'Applications machine à machine',
    },
    activity: {
        title: 'Activité de l’organisation',
        empty: 'Aucune activité pour le moment.',
        events: {
            create: 'Organisation créée',
            delete: 'Organisation supprimée',
            profile: 'Profil de l’organisation modifié',
            branding: 'Identité visuelle de l’organisation modifiée',
            security: 'Sécurité de l’organisation modifiée',
            member_add: 'Membre ajouté',
            member_remove: 'Membre retiré',
            owner: 'Propriété de l’organisation modifiée',
            role_create: 'Rôle de gestion créé',
            role_update: 'Rôle de gestion modifié',
            role_delete: 'Rôle de gestion supprimé',
            role_assign: 'Rôle de gestion attribué',
            role_unassign: 'Rôle de gestion retiré du membre',
            business_role: 'Rôles métier modifiés',
            invitation_create: 'Invitation envoyée',
            invitation_accept: 'Invitation acceptée',
            invitation_decline: 'Invitation refusée',
            invitation_revoke: 'Invitation révoquée',
            jit: 'Provisionnement JIT modifié',
            domain: 'Vérification du domaine e-mail',
            application: 'Connexions des applications modifiées',
            unknown: 'Activité de l’organisation',
        },
    },
    save: 'Enregistrer les modifications',
    cancel: 'Annuler',
    delete: 'Supprimer l’organisation',
    delete_confirmation: 'L’organisation et ses affiliations seront définitivement supprimées. Saisissez « {{name}} » pour confirmer.',
    deleted: 'Organisation supprimée.',
    load_failed: 'Impossible de charger les données de l’organisation. Réessayez.',
    permission_denied: 'Vous n’avez pas l’autorisation de consulter cette section.',
};
export default organizations;
